import api from './axios';

export interface DealHeader {
    business_name: string;
    requested_amount: number;
    eta: string;
    risk: string;
    updated_at: string;
    status: string;
}

export interface DealNote {
    author: string;
    time: string;
    text: string;
    avatar: string | null;
}

export interface DealOverview {
    metrics: {
        monthly_deposits: number;
        net_cash_flow: number;
        cash_coverage: string;
        volatility: string;
    };
    strengths: string[];
    weaknesses: string[];
    notes: DealNote[];
}

const dealsApi = {
    getOverview: async (slug: string): Promise<DealOverview> => {
        const response = await api.get(`/deals/${slug}/overview`);
        return response.data;
    },
    getHeader: async (slug: string): Promise<DealHeader> => {
        const response = await api.get(`/deals/${slug}/header`);
        return response.data;
    },
    addNote: async (slug: string, text: string): Promise<DealNote> => {
        const response = await api.post(`/deals/${slug}/notes`, { text, author: "User" });
        return response.data;
    },
    updateStatus: async (slug: string, status: string): Promise<void> => {
        await api.patch(`/deals/${slug}/status`, { status });
    }
};

export default dealsApi;
